import { render, staticRenderFns } from "./ApprovedReport.vue?vue&type=template&id=2cc0647a&"
import script from "./ApprovedReport.vue?vue&type=script&lang=js&"
export * from "./ApprovedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports